<template>
    <div class="base-notifications">
        <template v-for="(notification) in notifications">
            <base-alert :type="notification.type"
                        class="mb-2"
                        :delay="delay"
                        :dismissible="dismissible"
                        :elevated="elevated"
                        :large="large"
                        :pill="pill"
                        :small="small"
                        :xSmall="xSmall">
                {{ notification.message }}
            </base-alert>
        </template>
    </div>
</template>

<style>
.base-notifications {
    @apply z-100 fixed top-0 right-0 flex flex-col-reverse p-2;
}
</style>

<script>
import BaseAlert from "./BaseAlert.vue";

export default {
    name: "BaseNotifications",
    components: {BaseAlert},
    props: {
        delay: {
            type: Number,
            default: 5000,
        },
        dismissible: Boolean,
        elevated: Boolean,
        large: Boolean,
        pill: Boolean,
        small: Boolean,
        xSmall: Boolean,
    },
    methods: {
        info(message) {
            this.sendNotification("info", message);
        },
        success(message) {
            this.sendNotification("success", message);
        },
        warning(message) {
            this.sendNotification("warning", message);
        },
        danger(message) {
            this.sendNotification("danger", message);
        },
        sendNotification(type, message, delay) {
            this.notifications.push({message: message, type: type});
        }
    },
    data() {
        return {
            notifications: [],
        };
    },
}
</script>
